<template>
  <div class="app-container">
    <BjPage ref="BjPage" :label-width="'80px'" :query-params="queryParams" :col-span="colSpan" :get-action="queryApi" :serial="false" :searchBtnHide="true" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu">
      <template v-slot:tableOperation>
        <el-col>
          <el-button type="primary" class="main-btn" @click="onAdd">{{ $t('addText') }}</el-button>
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item">
            <template slot-scope="scope">{{ scope.row[col.prop] }}</template>
          </el-table-column>
          <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
            <template slot-scope="scope">
              <el-button type="text" class="edit-btn" @click="onEdit(scope.row)">{{ $t('editText') }}</el-button>
              <el-button type="text" class="edit-btn" @click="onDelete(scope.row)">{{ $t('delText') }}</el-button>
              <el-button type="text" class="edit-btn" @click="onEdit(scope.row, true)">{{ $t('viewText') }}</el-button>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>

    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" :title="title" :visible.sync="dialogVisible" width="500px" :before-close="handleClose">
      <el-form ref="form" :model="form" status-icon :rules="rules" label-width="120px" :disabled="disabled">
        <el-form-item :label="$t('serviceItem.table.name')" prop="name">
          <BjInput v-model="form.name" :maxlength="20" :placeholder="$t('inputText')" />
        </el-form-item>
        <el-form-item :label="$t('serviceItem.table.Serialnumber')" prop="rank">
          <BjInputNumber v-model="form.rank" :maxlength="5" :placeholder="$t('inputText')" />
        </el-form-item>
        <el-form-item :label="$t('serviceItem.table.timeConsuming')" prop="timeConsuming">
          <BjInputNumber v-model="form.timeConsuming" :maxlength="5" :placeholder="$t('inputText')" />
        </el-form-item>
        <!-- <el-form-item :label="$t('serviceItem.table.type')" prop="describe">
          <BjInput v-model="form.type" :maxlength="20" :placeholder="$t('inputText')" />
        </el-form-item> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{ $t('cancelText') }}</el-button>
        <el-button type="primary" @click="submitForm('form')">{{ $t('okText') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { serviceItem } from '@/api';
import pageMiXin from '@/utils/page-mixin.js';
const getDefaultForm = () => {
  return {
    name: "",
    rank: "",
    timeConsuming: "",
    type: "1",
    objectVersionNumber: ""
  }
}
export default {
  mixins: [pageMiXin],
  data() {
    return {
      queryApi: serviceItem.orderPalletList,
      labelList: [
        { label: this.$t('serviceItem.table.Serialnumber'), prop: 'rank', isCheck: true, disabled: false },
        { label: this.$t('serviceItem.table.name'), prop: 'name', isCheck: true, disabled: false, },
        { label: this.$t('serviceItem.table.timeConsuming'), prop: 'timeConsuming', isCheck: true, disabled: false },
        // { label: this.$t('serviceItem.table.type'), prop: 'type', isCheck: true, disabled: false },
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false },
      ],
      queryParams: {},
      form: getDefaultForm(),
      dialogVisible: false,
      rules: {
        rank: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        name: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        timeConsuming: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
      },
      disabled: false
    };
  },
  methods: {
    onDelete(row) {
      this.$confirm(this.$t('toast.delAllTipText'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      }).then(()=>{
        serviceItem.orderPalletDelete({ ids: [row.id] }).then(() => {
          this.$message.success(this.$t('toast.operationSuccessText'));
          this.reFresh()
        })
      })
    },
    onAdd(){
      this.dialogVisible = true;
      this.disabled = false;
      this.title = `${this.$t('addText')} ${this.$t('route.BusinessBillingServiceItem')}`
    },
    onEdit(row, flag = false){
      this.title = flag ? `${this.$t('route.BusinessBillingServiceItem')} ${this.$t('detailsText')}`: `${this.$t('editText')} ${this.$t('route.BusinessBillingServiceItem')}`
      this.disabled = flag
      this.form = row;
      this.dialogVisible = true
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid){
          const API = this.form.id ? 'orderPalletUpdate': 'orderPalletAdd'
          serviceItem[API](this.form).then((res)=>{
            if(!res.failed){
              this.$message.success(this.$t('toast.operationSuccessText'));
              this.handleClose()
              this.reFresh()
            }
          })
        }
      });
    },
    handleClose() {
      this.dialogVisible = false;
      this.form = getDefaultForm()
    },
  }
};
</script>